import { gql } from '@apollo/client'

export default gql`
    mutation appVersion($version: String) {
        appVersion(version: $version)
    }
`
